export default "__VITE_ASSET__CYIPFKLh__"